/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CodeInteroperabilite { 
    oid?: string;
    code: string;
    label: string;
    /**
     * Si ce code peut-être utilisé pour un doculment alimentant le DMP
     */
    validePourAlimentation?: boolean;
}

